import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import REACT_APP_API_URL from "../Api/ApiEnvironment";
import { useEffect } from "react";

const useAnalytics = () => {

    enum EventTypes {
        LOGIN = 'login',
        VIEW = 'view',
        UPLOAD = 'upload',
        CLICK = 'click',
    }

    const { getAccessTokenSilently, isAuthenticated } = useAuth0();

    const trackEvent = (event: string, data?: any) => {

        if (!isAuthenticated) return;

        const url = window.location.pathname;

        getAccessTokenSilently().then(token => {
        
            axios.put(REACT_APP_API_URL + '/analytics', 
                { event, url, data },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

        });
    }

    const handleClickEvent = (event) => {
        for (let clickTarget = event.target; clickTarget && clickTarget !== document; clickTarget = clickTarget.parentNode) {
          if (clickTarget.getAttribute('data-click-target')) {
            const target = clickTarget.getAttribute('data-click-target');
            const source = clickTarget.getAttribute('data-click-source') || null;
            trackEvent(EventTypes.CLICK, { target, source });
            break;
          }
        }
    };
    
    return {
        trackEvent,
        EventTypes,
        handleClickEvent
    }
}

export default useAnalytics;